"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ancona": {
    "754a8c42": [{
      "hkey": "4d820a37",
      "slug": "piano-stazione",
      "name": "Piano-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "archi": [{
      "hkey": "4d820a37",
      "slug": "piano-stazione",
      "name": "Piano-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ancona"
    }],
    "2c8150b3": [{
      "hkey": "896bae46",
      "slug": "brecce-bianche",
      "name": "Brecce Bianche",
      "primary": true,
      "skipSearch": false
    }],
    "b-bianche": [{
      "hkey": "896bae46",
      "slug": "brecce-bianche",
      "name": "Brecce Bianche",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e24b0c4f": [{
      "hkey": "dee9af34",
      "slug": "ghettarello-monteferro",
      "name": "Ghettarello-Monteferro",
      "primary": true,
      "skipSearch": false
    }],
    "ghettarello": [{
      "hkey": "dee9af34",
      "slug": "ghettarello-monteferro",
      "name": "Ghettarello-Monteferro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "66b79142": [{
      "hkey": "85351c44",
      "slug": "passo-varano-ponte-rosso",
      "name": "Passo Varano-Ponte Rosso",
      "primary": true,
      "skipSearch": false
    }],
    "passo-varano": [{
      "hkey": "85351c44",
      "slug": "passo-varano-ponte-rosso",
      "name": "Passo Varano-Ponte Rosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bdea4f09": [{
      "hkey": "4d820a37",
      "slug": "piano-stazione",
      "name": "Piano-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "piano": [{
      "hkey": "4d820a37",
      "slug": "piano-stazione",
      "name": "Piano-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "90ef7873": [{
      "hkey": "ed24dc4c",
      "slug": "poggio",
      "name": "Poggio",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-di-ancona": [{
      "hkey": "ed24dc4c",
      "slug": "poggio",
      "name": "Poggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fc67e72e": [{
      "hkey": "e6a7ba1e",
      "slug": "ancona",
      "name": "Ancona",
      "primary": true,
      "skipSearch": false
    }],
    "pontelungo": [{
      "hkey": "e6a7ba1e",
      "slug": "ancona",
      "name": "Ancona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0e67ffca": [{
      "hkey": "3c39bb77",
      "slug": "passetto-quartiere-adriatico",
      "name": "Passetto-Quartiere Adriatico",
      "primary": true,
      "skipSearch": false
    }],
    "q-adriatico": [{
      "hkey": "3c39bb77",
      "slug": "passetto-quartiere-adriatico",
      "name": "Passetto-Quartiere Adriatico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7b306684": [{
      "hkey": "3c39bb77",
      "slug": "passetto-quartiere-adriatico",
      "name": "Passetto-Quartiere Adriatico",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "3c39bb77",
      "slug": "passetto-quartiere-adriatico",
      "name": "Passetto-Quartiere Adriatico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ancona"
    }],
    "bdb5bebb": [{
      "hkey": "4d820a37",
      "slug": "piano-stazione",
      "name": "Piano-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "4d820a37",
      "slug": "piano-stazione",
      "name": "Piano-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ancona"
    }],
    "db367c7a": [{
      "hkey": "7fcda690",
      "slug": "barcaglione",
      "name": "Barcaglione",
      "primary": true,
      "skipSearch": false
    }],
    "taglio-di-barcaglione": [{
      "hkey": "7fcda690",
      "slug": "barcaglione",
      "name": "Barcaglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;